import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import '../tab/index.esm.js';
import '../tab-highlighter/index.esm.js';
import { EGDSNavigationType } from '../tabs/index.esm.js';
import styles from '../../styles/uitk-egds-tabs.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSTabAnchor extends React.Component {
  static displayName = 'EGDSTabAnchor';
  selectedLiRef;
  constructor(props) {
    super(props);
    this.selectedLiRef = React.createRef();
    this.preventClickEvent = this.preventClickEvent.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  handleOnClick(event) {
    const {
      disabled,
      handleClick,
      index,
      targetRef
    } = this.props;
    this.preventClickEvent(event);
    if (disabled) {
      return false;
    }
    if (typeof handleClick === 'function') {
      handleClick(index, event, targetRef);
    }
  }
  handleFocus(event) {
    const {
      handleFocus
    } = this.props;
    if (typeof handleFocus === 'function') {
      handleFocus(event);
    }
  }
  handleBlur(event) {
    const {
      handleBlur
    } = this.props;
    if (typeof handleBlur === 'function') {
      handleBlur(event);
    }
  }
  preventClickEvent(e) {
    const {
      externalLinks
    } = this.props;
    if (!externalLinks) {
      e.preventDefault();
    }
  }
  render() {
    const {
      className,
      disabled,
      name,
      targetURI,
      panelId,
      navigationType,
      selected,
      tabLinkAttr,
      anchorTabRef
    } = this.props;
    const wrapperClassNames = getClassNameList('uitk-tab', className, {
      [`active`]: selected
    });
    const anchorClassNames = getClassNameList('uitk-tab-anchor', {
      [`uitk-tab-anchor-selected`]: selected,
      [`uitk-tab-anchor-disabled`]: disabled
    });
    const isJumplink = navigationType === EGDSNavigationType.JUMPLINK;
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
      jsx("li", {
        "data-stid": selected ? 'uitk-tab-active' : null,
        role: isJumplink ? 'listitem' : 'presentation',
        className: wrapperClassNames,
        onClick: this.preventClickEvent,
        ref: selected ? this.selectedLiRef : '',
        children: jsx("a", {
          href: targetURI,
          ref: anchorTabRef,
          className: anchorClassNames,
          ...(!isJumplink && {
            'aria-controls': panelId
          }),
          ...(isJumplink ? {
            'aria-current': selected
          } : {
            'aria-selected': selected
          }),
          ...tabLinkAttr,
          role: isJumplink ? 'link' : 'tab',
          "data-toggle": "tab",
          onClick: this.handleOnClick,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          draggable: false,
          children: jsx("span", {
            className: getClassNameList('uitk-tab-text'),
            children: name
          })
        })
      })
    );
  }
}
export { EGDSTabAnchor };